import { useMemo, useState } from 'react';
import { GridTabIndexSettings, TabFieldConfig } from '../../../../../components/grids/default/gridTabIndexSettings';
import { useDocumentTabSettings } from '../../../../../system/hooks/useDocumentTabSettings';
import { t } from 'i18next';

export const useInvoiceItemTabSettings = () => {
    const [showSettings, setShowSettings] = useState(false);
    
    const fields: TabFieldConfig[] = useMemo(() => [
        { id: 'idGoodsGlobal', label: 'Наименование', required: true },
        { id: 'idScalingRatioGlobal', label: 'Единица измерения', required: true },
        { id: 'countDocs', label: 'Количество по документу', required: true },
        { id: 'damageQuantity', label: 'Бой' },
        { id: 'defectQuantity', label: 'Брак' },
        { id: 'shortageQuantity', label: 'Недостача' },
        { id: 'inputKiz', label: 'Ввод КИЗ' },
        { id: 'manufacturerPrice', label: 'Цена производителя' },
        { id: 'manufacturerMarginalPrice', label: 'Предельная цена произв.' },
        { id: 'vatRateWholesale', label: 'Ставка НДС пост.', required: true },
        { id: 'suppliersPrice', label: 'Цена б/НДС, пост. ', required: true },
        { id: 'supplierAmount', label: 'Сумма б/НДС, пост. ', required: true },
        { id: 'supplierVatAmount', label: 'Сумма НДС, пост.' },
        { id: 'supplierPriceWithVat', label: 'Цена с НДС, пост.', required: true },
        { id: 'amountOfThePaymentWithVat', label: 'Сумма с НДС, пост.', required: true },
        { id: 'retailVatRate', label: 'Ставка НДС, розн.', required: true },
        { id: 'percentageOfMarkupRetailChanged', label: 'Наценка %, розн.' },
        { id: 'retailPrice', label: 'Цена б/НДС, розн. ', required: true },
        { id: 'retailAmountWithoutVat', label: 'Сумма розн. б/НДС', required: true },
        { id: 'retailAmountWithVatSum', label: 'Сумма НДС, розн.' },
        { id: 'sellingPrice', label: 'Цена с НДС, розн. ', required: true },
        { id: 'retailAmountWithVat', label: 'Сумма с НДС, розн.', required: true },
        { id: 'priceContract', label: 'Цена контракта' },
        { id: 'cancelButton', label: 'Отмена (кнопка)' },
        { id: 'okButton', label: 'Ok (кнопка)' },

    ], []);

    const { 
        settings, 
        defaultSettings,
        updateSettings, 
        getTabIndex,
        getBooleanSetting,
        getStoreUISettings,
    } = useDocumentTabSettings('invoiceItemCreator');

    const SettingsModal = showSettings ? (
        <GridTabIndexSettings
            documentKey="invoiceItemCreator"
            documentName={t("documents.invoice.itemPrefix")}
            fields={fields}
            settings={settings}
            defaultSettings={defaultSettings}
            onSave={(newSettings) => {
                updateSettings(newSettings);
                setShowSettings(false);
            }}
            onCancel={() => setShowSettings(false)}
            className="documentTabSettings"
        />
    ) : null;

    return {
        getTabIndex,
        getBooleanSetting,
        getStoreUISettings,
        showSettings: () => setShowSettings(true),
        hideSettings: () => setShowSettings(false),
        SettingsModal
    };
};